import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1242.24,0 L1242.24,564.705882 L1016.47059,564.705882 L1016.47059,865.807059 L1694.11765,865.807059 L1694.11765,1355.29412 L1920,1355.29412 L1920,1920 L1355.18118,1920 L1355.18118,1355.29412 L1581.17647,1355.29412 L1581.17647,978.861176 L1016.47059,978.861176 L1016.47059,1355.29412 L1242.24,1355.29412 L1242.24,1920 L677.647059,1920 L677.647059,1355.29412 L903.529412,1355.29412 L903.529412,978.861176 L338.710588,978.861176 L338.710588,1355.29412 L564.705882,1355.29412 L564.705882,1920 L0,1920 L0,1355.29412 L225.769412,1355.29412 L225.769412,865.807059 L903.529412,865.807059 L903.529412,564.705882 L677.647059,564.705882 L677.647059,0 L1242.24,0 Z M1807.05882,1468.34824 L1468.12235,1468.34824 L1468.12235,1807.17176 L1807.05882,1807.17176 L1807.05882,1468.34824 Z M1129.41176,1468.34824 L790.588235,1468.34824 L790.588235,1807.17176 L1129.41176,1807.17176 L1129.41176,1468.34824 Z M451.764706,1468.34824 L112.941176,1468.34824 L112.941176,1807.17176 L451.764706,1807.17176 L451.764706,1468.34824 Z M1129.41176,112.941176 L790.588235,112.941176 L790.588235,451.877647 L1129.41176,451.877647 L1129.41176,112.941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSubaccountsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSubaccountsLine, _Component);

  var _super = _createSuper(IconSubaccountsLine);

  function IconSubaccountsLine() {
    _classCallCheck(this, IconSubaccountsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSubaccountsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSubaccounts",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSubaccountsLine.displayName = "IconSubaccountsLine";
  return IconSubaccountsLine;
}(Component);

IconSubaccountsLine.glyphName = 'subaccounts';
IconSubaccountsLine.variant = 'Line';
IconSubaccountsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSubaccountsLine;
export { IconSubaccountsLine };